import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { Decision, ApprovalLevel, Languages } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { SupplierRegistrationApprovalDecisionDTO } from 'src/app/shared/models/e-tender.model';
import { SupplierService } from 'src/app/shared/services/supplier.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'supplier-registration-aproval',
  templateUrl: './supplier-registration-aproval.component.html',
  styles: []
})
export class SupplierRegistrationAprovalComponent implements OnInit {
  //#region PROPERTIES
  /////////////////////*Input - Outputs -ViewChild*/////////////////////
  @ViewChild('supplierRegistrationAprovalDecision',{static: false}) supplierRegistrationAprovalDecisionControls: ElementRef;
  @Output() isSubmitSucceededEvent = new EventEmitter<boolean>();
  @Input() ApprovalLevelInput: ApprovalLevel;
  @Input() WFAppInstanceIDInput: string;
  @Input() SupplierIdInput: string;
  /////////////////////*Language*/////////////////////
  public Languages: any = Languages;
  public currentLanguage: any;
  SupplierRegistrationAprovalForm: FormGroup;
  public Decision: any = Decision;
  private isFormSubmitted: boolean = false;
  public submitFail: boolean = false;
  private showRejectionReason: boolean;

  private responseObj: ResponseObject = new ResponseObject();
  public isSubmitSucceeded: boolean = false;
  supplierRegistrationApprovalDecision: SupplierRegistrationApprovalDecisionDTO;
  cuurentUser: User = new User();
  private myTasksUrl: string;
  public isTaskCompletedByAnotherUser: boolean = false;
  public isInternalServerError: boolean = false;

  //#endregion
  //#region CONSTRUCTOR
  constructor(
    private formBuilder: FormBuilder,
    private globalServices: GlobalServices,
    private supplierService: SupplierService,
  ) {
    this.cuurentUser = this.globalServices.user;
    this.currentLanguage = this.globalServices.getLanguage();

    if (this.currentLanguage == Languages.English) {
      // this.myTasksUrl = "/English/Pages/Workspace.aspx#/myTasks";
      this.myTasksUrl = "/English" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "myTasks";
    } else {
      // this.myTasksUrl = "/Arabic/Pages/Workspace.aspx#/myTasks";
      this.myTasksUrl = "/Arabic" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "myTasks";
    }

    this.showRejectionReason = false;
    this.buildSupplierRegistrationAprovalForm();
  }
  //#endregion
  //#region EVENTS
  ngOnInit() {
  }
  //#endregion
  //#region FUNCTIONS
  buildSupplierRegistrationAprovalForm(): void {
    this.SupplierRegistrationAprovalForm = this.formBuilder.group({
      AprovalDecision: new FormControl('', Validators.required),
      RejectionReason: [''],
      RejectionMail: ['']
    })
  }
  get getFormControls() {
    return this.SupplierRegistrationAprovalForm.controls;
  }
  onDecisionChange(): void {

    const rejectionReason = this.SupplierRegistrationAprovalForm['controls']['RejectionReason'];
    const rejectionMail = this.SupplierRegistrationAprovalForm['controls']['RejectionMail'];
    switch (+this.SupplierRegistrationAprovalForm.controls['AprovalDecision'].value) {
      case Decision.Accept:
        rejectionReason.setValue('');
        rejectionReason.clearValidators();
        rejectionReason.updateValueAndValidity();
        rejectionMail.setValue(false);
        rejectionMail.clearValidators();
        rejectionMail.updateValueAndValidity();
        this.showRejectionReason = false;
        break;
      case Decision.Reject:
        rejectionReason.setValidators([Validators.maxLength(500), CustomValidators.textSpaceValidator(), Validators.required]);
        rejectionReason.updateValueAndValidity();
        rejectionMail.setValue(true);
        rejectionMail.updateValueAndValidity();
        this.showRejectionReason = true;
        break;
      default:
        //Do Nothing
        break;
    }
  }

  submit(): void {

    this.isFormSubmitted = true;
    const formInValidControls = this.supplierRegistrationAprovalDecisionControls.nativeElement.querySelectorAll('.ng-invalid');
    if (!this.SupplierRegistrationAprovalForm.valid && formInValidControls.length > 0) {
      if (formInValidControls.length > 0)
        formInValidControls[0].focus();
    } else {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      // if(this.rebateRequestId && this.rebateRequestId != "")
      this.submitSupplierRegistrationDecision();
    }
  }
  submitSupplierRegistrationDecision(): void {
    this.supplierRegistrationApprovalDecision = this.SupplierRegistrationAprovalForm.getRawValue();
    this.supplierRegistrationApprovalDecision.WFAppInstanceID = this.WFAppInstanceIDInput;
    this.supplierRegistrationApprovalDecision.AdminEmail = this.cuurentUser.UserName;
    this.supplierRegistrationApprovalDecision.SupplierId = this.SupplierIdInput;
    this.supplierRegistrationApprovalDecision.AprovalDecision = +this.supplierRegistrationApprovalDecision.AprovalDecision;
    if (this.ApprovalLevelInput == ApprovalLevel.Purchasing) {
      // alert("Submit Purchasing!");
      this.supplierService.SubmitSupplierRegistrationPurchasingAdminDecision(this.supplierRegistrationApprovalDecision).subscribe(
        data => this.responseObj = data,
        () => this.submitSupplierRegistrationDecisionFailed(),
        () => this.submitSupplierRegistrationDecisionCompleted()
      );
    } else if (this.ApprovalLevelInput == ApprovalLevel.Technical) {
      // alert("Submit Technical!");
      this.supplierService.SubmitSupplierRegistrationTechnicalAdminDecision(this.supplierRegistrationApprovalDecision).subscribe(
        data => this.responseObj = data,
        () => this.submitSupplierRegistrationDecisionFailed(),
        () => this.submitSupplierRegistrationDecisionCompleted()
      );
    }
  }

  submitSupplierRegistrationDecisionFailed(): void {
    this.isSubmitSucceeded = false;
    this.submitFail = true;
    this.isSubmitSucceededEvent.emit(true);
    this.globalServices.isLoaderEnabled = false;
  }

  submitSupplierRegistrationDecisionCompleted(): void {
    if (this.responseObj.Success) {
      //Enable Confirmation
      this.isSubmitSucceeded = true;
      this.submitFail = false;
      this.isSubmitSucceededEvent.emit(true);
    } else {
      //Enable Error
      this.isTaskCompletedByAnotherUser = this.responseObj.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null ? true : false;
      if (this.isTaskCompletedByAnotherUser) {
        this.isSubmitSucceeded = true;
        this.submitFail = false;
        this.isSubmitSucceededEvent.emit(true);
      } else {
        this.isSubmitSucceeded = false;
        this.submitFail = true;
        this.isSubmitSucceededEvent.emit(false);
      }
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  //#endregion
}
